import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions, DIGIFIER_API_URL } from './common';

export const fetchDocumentUploadToken = async (applicationNumber, documentType, apiReqParams = {}) => {
  const url = `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/getUploadToken/${applicationNumber}`;
  const result = await httpMethodFunctions.get(
    url, // URL
    {
      params: {
        document_type: documentType,
        ...apiReqParams,
      },
    }
  );

  return result?.data;
};

export const uploadDocument = async ({ uploadToken, file }) => {
  const uploadUrl = `${DIGIFIER_API_URL}`;

  let retryCount = 0;
  let latestError;

  while (retryCount < 3) {
    try {
      const response = await httpMethodFunctions.post(
        `${uploadUrl}/upload/`, // URL
        file, // Data
        {
          // Config
          params: { upload_token: uploadToken },
          headers: { 'Content-Type': file.type },
        }
      );

      return response;
    } catch (e) {
      retryCount++;
      latestError = e;
    }
  }

  throw latestError;
};